import Enum from './Enum.js';

export default class EvaluationTermStatus extends Enum {
  static OPEN = new EvaluationTermStatus('OPEN', '評価中');
  static CLOSED = new EvaluationTermStatus('CLOSED', '完了');
}
